import { tryGetHostApi } from "./externalApi";
export async function getHostPackageStateApi(minVersion = 1, targetVersion = 1) {
    return (await tryGetHostApi("PackageState", minVersion, targetVersion));
}
export async function getIsPackageInstalled(pfn) {
    const packageStateApi = await tryGetHostApi("PackageState", 1, 1);
    let isPackageInstalled = false;
    if (packageStateApi) {
        isPackageInstalled = await packageStateApi.isPackageInstalled(pfn);
    }
    return isPackageInstalled;
}
export async function addPackageStateEventListener(listener) {
    const packageStateApi = await tryGetHostApi("PackageState", 1, 1);
    if (packageStateApi) {
        await packageStateApi.addEventListener("packagestateupdated", listener);
    }
}
export async function removePackageStateEventListener(listener) {
    const packageStateApi = await tryGetHostApi("PackageState", 1, 1);
    if (packageStateApi) {
        await packageStateApi.removeEventListener("packagestateupdated", listener);
    }
}
